export class Pipeline{
    constructor(){
        var _pipeline = [];

        // debug
        this.pipeline = _pipeline; 

        Object.defineProperty(this,'add',{
            value : function(x){ _pipeline.push(x); }
        });

        Object.defineProperty(this,'run',{
            value : function(data){
               var callback = (acc, curr) => acc.then(curr)
               return _pipeline.reduce(callback,Promise.resolve(data))
            }
        });

        Object.defineProperty(this,'reset',{
            value : ()=>{ _pipeline = [] }
        })
    }
}
